import { useState, useEffect, useRef } from 'react';
import { FaPhone, FaChevronDown } from 'react-icons/fa';
import { getTranslation } from '../../utils/translations';
import './PhoneInput.css';

const COUNTRY_CODES = [
  // Gulf Countries (أولوية)
  { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦', nameAr: 'السعودية', id: 'sa' },
  { code: '+971', name: 'UAE', flag: '🇦🇪', nameAr: 'الإمارات', id: 'ae' },
  { code: '+965', name: 'Kuwait', flag: '🇰🇼', nameAr: 'الكويت', id: 'kw' },
  { code: '+973', name: 'Bahrain', flag: '🇧🇭', nameAr: 'البحرين', id: 'bh' },
  { code: '+974', name: 'Qatar', flag: '🇶🇦', nameAr: 'قطر', id: 'qa' },
  { code: '+968', name: 'Oman', flag: '🇴🇲', nameAr: 'عمان', id: 'om' },

  // Arab Countries
  { code: '+962', name: 'Jordan', flag: '🇯🇴', nameAr: 'الأردن', id: 'jo' },
  { code: '+961', name: 'Lebanon', flag: '🇱🇧', nameAr: 'لبنان', id: 'lb' },
  { code: '+20', name: 'Egypt', flag: '🇪🇬', nameAr: 'مصر', id: 'eg' },
  { code: '+963', name: 'Syria', flag: '🇸🇾', nameAr: 'سوريا', id: 'sy' },
  { code: '+964', name: 'Iraq', flag: '🇮🇶', nameAr: 'العراق', id: 'iq' },
  { code: '+967', name: 'Yemen', flag: '🇾🇪', nameAr: 'اليمن', id: 'ye' },
  { code: '+212', name: 'Morocco', flag: '🇲🇦', nameAr: 'المغرب', id: 'ma' },
  { code: '+213', name: 'Algeria', flag: '🇩🇿', nameAr: 'الجزائر', id: 'dz' },
  { code: '+216', name: 'Tunisia', flag: '🇹🇳', nameAr: 'تونس', id: 'tn' },
  { code: '+218', name: 'Libya', flag: '🇱🇾', nameAr: 'ليبيا', id: 'ly' },
  { code: '+249', name: 'Sudan', flag: '🇸🇩', nameAr: 'السودان', id: 'sd' },
  { code: '+222', name: 'Mauritania', flag: '🇲🇷', nameAr: 'موريتانيا', id: 'mr' },
  { code: '+253', name: 'Djibouti', flag: '🇩🇯', nameAr: 'جيبوتي', id: 'dj' },
  { code: '+252', name: 'Somalia', flag: '🇸🇴', nameAr: 'الصومال', id: 'so' },
  { code: '+970', name: 'Palestine', flag: '🇵🇸', nameAr: 'فلسطين', id: 'ps' },

  // Major International Countries
  { code: '+1', name: 'United States', flag: '🇺🇸', nameAr: 'الولايات المتحدة', id: 'us' },
  { code: '+1', name: 'Canada', flag: '🇨🇦', nameAr: 'كندا', id: 'ca' },
  { code: '+44', name: 'United Kingdom', flag: '🇬🇧', nameAr: 'المملكة المتحدة', id: 'gb' },
  { code: '+33', name: 'France', flag: '🇫🇷', nameAr: 'فرنسا', id: 'fr' },
  { code: '+49', name: 'Germany', flag: '🇩🇪', nameAr: 'ألمانيا', id: 'de' },
  { code: '+39', name: 'Italy', flag: '🇮🇹', nameAr: 'إيطاليا', id: 'it' },
  { code: '+34', name: 'Spain', flag: '🇪🇸', nameAr: 'إسبانيا', id: 'es' },
  { code: '+31', name: 'Netherlands', flag: '🇳🇱', nameAr: 'هولندا', id: 'nl' },
  { code: '+41', name: 'Switzerland', flag: '🇨🇭', nameAr: 'سويسرا', id: 'ch' },
  { code: '+43', name: 'Austria', flag: '🇦🇹', nameAr: 'النمسا', id: 'at' },
  { code: '+32', name: 'Belgium', flag: '🇧🇪', nameAr: 'بلجيكا', id: 'be' },
  { code: '+46', name: 'Sweden', flag: '🇸🇪', nameAr: 'السويد', id: 'se' },
  { code: '+47', name: 'Norway', flag: '🇳🇴', nameAr: 'النرويج', id: 'no' },
  { code: '+45', name: 'Denmark', flag: '🇩🇰', nameAr: 'الدنمارك', id: 'dk' },
  { code: '+358', name: 'Finland', flag: '🇫🇮', nameAr: 'فنلندا', id: 'fi' },

  // Asia Pacific
  { code: '+86', name: 'China', flag: '🇨🇳', nameAr: 'الصين', id: 'cn' },
  { code: '+81', name: 'Japan', flag: '🇯🇵', nameAr: 'اليابان', id: 'jp' },
  { code: '+82', name: 'South Korea', flag: '🇰🇷', nameAr: 'كوريا الجنوبية', id: 'kr' },
  { code: '+91', name: 'India', flag: '🇮🇳', nameAr: 'الهند', id: 'in' },
  { code: '+92', name: 'Pakistan', flag: '🇵🇰', nameAr: 'باكستان', id: 'pk' },
  { code: '+880', name: 'Bangladesh', flag: '🇧🇩', nameAr: 'بنغلاديش', id: 'bd' },
  { code: '+94', name: 'Sri Lanka', flag: '🇱🇰', nameAr: 'سريلانكا', id: 'lk' },
  { code: '+95', name: 'Myanmar', flag: '🇲🇲', nameAr: 'ميانمار', id: 'mm' },
  { code: '+66', name: 'Thailand', flag: '🇹🇭', nameAr: 'تايلاند', id: 'th' },
  { code: '+84', name: 'Vietnam', flag: '🇻🇳', nameAr: 'فيتنام', id: 'vn' },
  { code: '+60', name: 'Malaysia', flag: '🇲🇾', nameAr: 'ماليزيا', id: 'my' },
  { code: '+65', name: 'Singapore', flag: '🇸🇬', nameAr: 'سنغافورة', id: 'sg' },
  { code: '+62', name: 'Indonesia', flag: '🇮🇩', nameAr: 'إندونيسيا', id: 'id' },
  { code: '+63', name: 'Philippines', flag: '🇵🇭', nameAr: 'الفلبين', id: 'ph' },
  { code: '+61', name: 'Australia', flag: '🇦🇺', nameAr: 'أستراليا', id: 'au' },
  { code: '+64', name: 'New Zealand', flag: '🇳🇿', nameAr: 'نيوزيلندا', id: 'nz' },

  // Africa
  { code: '+27', name: 'South Africa', flag: '🇿🇦', nameAr: 'جنوب أفريقيا', id: 'za' },
  { code: '+234', name: 'Nigeria', flag: '🇳🇬', nameAr: 'نيجيريا', id: 'ng' },
  { code: '+233', name: 'Ghana', flag: '🇬🇭', nameAr: 'غانا', id: 'gh' },
  { code: '+254', name: 'Kenya', flag: '🇰🇪', nameAr: 'كينيا', id: 'ke' },
  { code: '+255', name: 'Tanzania', flag: '🇹🇿', nameAr: 'تنزانيا', id: 'tz' },
  { code: '+256', name: 'Uganda', flag: '🇺🇬', nameAr: 'أوغندا', id: 'ug' },
  { code: '+251', name: 'Ethiopia', flag: '🇪🇹', nameAr: 'إثيوبيا', id: 'et' },

  // Americas
  { code: '+52', name: 'Mexico', flag: '🇲🇽', nameAr: 'المكسيك', id: 'mx' },
  { code: '+55', name: 'Brazil', flag: '🇧🇷', nameAr: 'البرازيل', id: 'br' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷', nameAr: 'الأرجنتين', id: 'ar' },
  { code: '+56', name: 'Chile', flag: '🇨🇱', nameAr: 'تشيلي', id: 'cl' },
  { code: '+57', name: 'Colombia', flag: '🇨🇴', nameAr: 'كولومبيا', id: 'co' },
  { code: '+51', name: 'Peru', flag: '🇵🇪', nameAr: 'بيرو', id: 'pe' },
  { code: '+58', name: 'Venezuela', flag: '🇻🇪', nameAr: 'فنزويلا', id: 've' },

  // Europe (Additional)
  { code: '+7', name: 'Russia', flag: '🇷🇺', nameAr: 'روسيا', id: 'ru' },
  { code: '+48', name: 'Poland', flag: '🇵🇱', nameAr: 'بولندا', id: 'pl' },
  { code: '+420', name: 'Czech Republic', flag: '🇨🇿', nameAr: 'التشيك', id: 'cz' },
  { code: '+421', name: 'Slovakia', flag: '🇸🇰', nameAr: 'سلوفاكيا', id: 'sk' },
  { code: '+36', name: 'Hungary', flag: '🇭🇺', nameAr: 'المجر', id: 'hu' },
  { code: '+40', name: 'Romania', flag: '🇷🇴', nameAr: 'رومانيا', id: 'ro' },
  { code: '+359', name: 'Bulgaria', flag: '🇧🇬', nameAr: 'بلغاريا', id: 'bg' },
  { code: '+30', name: 'Greece', flag: '🇬🇷', nameAr: 'اليونان', id: 'gr' },
  { code: '+90', name: 'Turkey', flag: '🇹🇷', nameAr: 'تركيا', id: 'tr' },
  { code: '+98', name: 'Iran', flag: '🇮🇷', nameAr: 'إيران', id: 'ir' },
  { code: '+93', name: 'Afghanistan', flag: '🇦🇫', nameAr: 'أفغانستان', id: 'af' },

  // Additional Countries
  { code: '+972', name: 'Israel', flag: '🇮🇱', nameAr: 'إسرائيل', id: 'il' },
  { code: '+374', name: 'Armenia', flag: '🇦🇲', nameAr: 'أرمينيا', id: 'am' },
  { code: '+994', name: 'Azerbaijan', flag: '🇦🇿', nameAr: 'أذربيجان', id: 'az' },
  { code: '+995', name: 'Georgia', flag: '🇬🇪', nameAr: 'جورجيا', id: 'ge' },
  { code: '+996', name: 'Kyrgyzstan', flag: '🇰🇬', nameAr: 'قيرغيزستان', id: 'kg' },
  { code: '+998', name: 'Uzbekistan', flag: '🇺🇿', nameAr: 'أوزبكستان', id: 'uz' },
  { code: '+992', name: 'Tajikistan', flag: '🇹🇯', nameAr: 'طاجيكستان', id: 'tj' },
  { code: '+993', name: 'Turkmenistan', flag: '🇹🇲', nameAr: 'تركمانستان', id: 'tm' },
  { code: '+7', name: 'Kazakhstan', flag: '🇰🇿', nameAr: 'كازاخستان', id: 'kz' },
];

const PhoneInput = ({ 
  value, 
  onChange, 
  language, 
  error, 
  disabled = false,
  placeholder,
  countryCode = '+966'
}) => {
  const [selectedCountry, setSelectedCountry] = useState(
    COUNTRY_CODES.find(country => country.code === countryCode) || COUNTRY_CODES[0]
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(value || '');
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm('');
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
    setSearchTerm('');
    // Notify parent component
    if (onChange) {
      onChange({
        phone: phoneNumber,
        countryCode: country.code,
        fullNumber: country.code + phoneNumber
      });
    }
  };

  const filteredCountries = COUNTRY_CODES.filter(country => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      country.name.toLowerCase().includes(search) ||
      country.nameAr.includes(search) ||
      country.code.includes(search)
    );
  });

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Remove any non-digit characters
    inputValue = inputValue.replace(/\D/g, '');

    // Country-specific formatting and limits
    const countryLimits = {
      '+966': { max: 9, autoPrefix: '5' }, // Saudi Arabia
      '+971': { max: 9 }, // UAE
      '+965': { max: 8 }, // Kuwait
      '+973': { max: 8 }, // Bahrain
      '+974': { max: 8 }, // Qatar
      '+968': { max: 8 }, // Oman
      '+962': { max: 9 }, // Jordan
      '+961': { max: 8 }, // Lebanon
      '+20': { max: 10 }, // Egypt
      '+1': { max: 10 }, // US/Canada
      '+44': { max: 11 }, // UK
      '+33': { max: 9 }, // France
      '+49': { max: 12 }, // Germany
      '+91': { max: 10 }, // India
      '+86': { max: 11 }, // China
      '+81': { max: 11 }, // Japan
      '+82': { max: 11 }, // South Korea
    };

    const countryConfig = countryLimits[selectedCountry.code] || { max: 15 };

    // Apply length limit
    if (inputValue.length > countryConfig.max) {
      inputValue = inputValue.slice(0, countryConfig.max);
    }

    // Auto-prefix for specific countries (like Saudi Arabia)
    if (countryConfig.autoPrefix && inputValue.length === 1 && inputValue !== countryConfig.autoPrefix) {
      inputValue = countryConfig.autoPrefix + inputValue;
    }

    setPhoneNumber(inputValue);

    // Notify parent component
    if (onChange) {
      onChange({
        phone: inputValue,
        countryCode: selectedCountry.code,
        fullNumber: selectedCountry.code + inputValue
      });
    }
  };

  const validatePhoneNumber = (phone, countryCode) => {
    if (!phone) return false;

    // Country-specific validation patterns
    const validationPatterns = {
      '+966': /^5[0-9]{8}$/, // Saudi Arabia: 9 digits starting with 5
      '+971': /^[0-9]{9}$/, // UAE: 9 digits
      '+965': /^[0-9]{8}$/, // Kuwait: 8 digits
      '+973': /^[0-9]{8}$/, // Bahrain: 8 digits
      '+974': /^[0-9]{8}$/, // Qatar: 8 digits
      '+968': /^[0-9]{8}$/, // Oman: 8 digits
      '+962': /^[0-9]{9}$/, // Jordan: 9 digits
      '+961': /^[0-9]{8}$/, // Lebanon: 8 digits
      '+20': /^[0-9]{10}$/, // Egypt: 10 digits
      '+1': /^[0-9]{10}$/, // US/Canada: 10 digits
      '+44': /^[0-9]{10,11}$/, // UK: 10-11 digits
      '+33': /^[0-9]{9}$/, // France: 9 digits
      '+49': /^[0-9]{10,12}$/, // Germany: 10-12 digits
      '+91': /^[0-9]{10}$/, // India: 10 digits
      '+86': /^[0-9]{11}$/, // China: 11 digits
      '+81': /^[0-9]{10,11}$/, // Japan: 10-11 digits
      '+82': /^[0-9]{10,11}$/, // South Korea: 10-11 digits
    };

    const pattern = validationPatterns[countryCode];
    if (pattern) {
      return pattern.test(phone);
    }

    // Basic validation for other countries: 7-15 digits
    return /^[0-9]{7,15}$/.test(phone);
  };

  const isValid = validatePhoneNumber(phoneNumber, selectedCountry.code);

  const getPlaceholder = () => {
    if (placeholder) return placeholder;

    // Country-specific placeholders
    const placeholders = {
      '+966': '5xxxxxxxx', // Saudi Arabia
      '+971': 'xxxxxxxxx', // UAE
      '+965': 'xxxxxxxx', // Kuwait
      '+973': 'xxxxxxxx', // Bahrain
      '+974': 'xxxxxxxx', // Qatar
      '+968': 'xxxxxxxx', // Oman
      '+962': 'xxxxxxxxx', // Jordan
      '+961': 'xxxxxxxx', // Lebanon
      '+20': 'xxxxxxxxxx', // Egypt
      '+1': 'xxxxxxxxxx', // US/Canada
      '+44': 'xxxxxxxxxxx', // UK
      '+33': 'xxxxxxxxx', // France
      '+49': 'xxxxxxxxxxxx', // Germany
      '+91': 'xxxxxxxxxx', // India
      '+86': 'xxxxxxxxxxx', // China
      '+81': 'xxxxxxxxxxx', // Japan
      '+82': 'xxxxxxxxxxx', // South Korea
    };

    return placeholders[selectedCountry.code] || (language === 'ar' ? 'رقم الهاتف' : 'Phone number');
  };

  return (
    <div className={`phone-input-container ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      <label className="phone-input-label">
        <FaPhone className="phone-input-icon" />
        {getTranslation('phoneNumber', language)} *
      </label>
      
      <div className={`phone-input-wrapper ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
        {/* Country Code Selector */}
        <div
          className="country-selector"
          onClick={() => {
            if (!disabled) {
              setIsDropdownOpen(!isDropdownOpen);
            }
          }}
          ref={dropdownRef}
        >
          <span className="country-flag">{selectedCountry.flag}</span>
          <span className="country-code">{selectedCountry.code}</span>
          <FaChevronDown className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} />

          {isDropdownOpen && (
            <div className="country-dropdown">
              {/* Search Input */}
              <div className="country-search">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder={language === 'ar' ? 'البحث عن دولة...' : 'Search country...'}
                  className="country-search-input"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              {/* Countries List */}
              <div className="countries-list">
                {filteredCountries.length > 0 ? (
                  filteredCountries.map((country, index) => (
                    <div
                      key={country.id || `${country.code}-${index}`}
                      className={`country-option ${selectedCountry.code === country.code && selectedCountry.name === country.name ? 'selected' : ''}`}
                      onClick={() => handleCountrySelect(country)}
                    >
                      <span className="country-flag">{country.flag}</span>
                      <span className="country-name">
                        {language === 'ar' ? country.nameAr : country.name}
                      </span>
                      <span className="country-code">{country.code}</span>
                    </div>
                  ))
                ) : (
                  <div className="no-countries-found">
                    {language === 'ar' ? 'لم يتم العثور على دول' : 'No countries found'}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        
        {/* Phone Number Input */}
        <input
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneChange}
          placeholder={getPlaceholder()}
          className={`phone-number-input ${!isValid && phoneNumber ? 'invalid' : ''}`}
          disabled={disabled}
          dir="ltr"
        />
      </div>
      
      {/* Validation Message */}
      {error && (
        <div className="phone-input-error">
          {error}
        </div>
      )}
      
      {!error && phoneNumber && !isValid && (
        <div className="phone-input-warning">
          {selectedCountry.code === '+966' 
            ? (language === 'ar' ? 'يجب أن يبدأ الرقم بـ 5 ويتكون من 9 أرقام' : 'Number must start with 5 and be 9 digits')
            : (language === 'ar' ? 'رقم الهاتف غير صحيح' : 'Invalid phone number')
          }
        </div>
      )}
    </div>
  );
};

export default PhoneInput;
